import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Step, Stepper } from "react-form-stepper";
import ConfigurationBot from "./stepOne";
import StepThree from "./stepThree";
import StepTwo from "./stepTwo";
import { handleLoader, handleNotFound, setAvtarLogoName, setBotLogoName, setbrandGuidelineName, setcsvName, setsocialMediaPostName, setUploadPolicyFileName } from "redux/counterSlice";
import { useDispatch, useSelector } from "react-redux";
import { botConfigurations, getBotConfigurations } from "services/chatBotService";
import { ToastContent, toast } from 'react-toastify';
import { FormProvider } from "react-hook-form";
import BrandPersonality from "./BrandPersonality";
import _ from 'lodash';
import * as myconst from "../../constants/index"

type configurationData = {
  organizationName: String
  organizationURL: String
  domainName: String
  description: String
}
interface Industry {
  name: string;
  // value: string;
}
interface Item {
  dialect_database?: any;
  action: Industry;
  prompt?: string;
  host?: string;
  port?: number;
  top_n?: number;
  acceptance_threshold?: number;
  product_recommendation_tool?: string;
  feature_column_list_output?: string;
  feature_column_list_input?: string;
  product_page_chat_tool_desc?: string;
  return_policy_tool?: string;
  username?: string;
  password?: string;
  database?: string;
  tables?: string;
  showPassword?: boolean;
}
interface table_type {
  table_name: string,
  column_name: string
}
interface table_type_getting {
  table_name: string,
  column_name: string[]
}
const defaultStyle = {
  activeBgColor: '#ed1d24',
  activeTextColor: 'transparent',
  completedBgColor: '#a10308',
  completedTextColor: '#ffffff',
  inactiveBgColor: '#C8C8C8',
  inactiveTextColor: 'transparent',
  size: '16px',
  circleFontSize: '0',
  labelFontSize: '0.875rem',
  borderRadius: '50%',
  fontWeight: 500
}
const BotConfiguration = () => {
  const csvName = useSelector((state: any) => state.counter.csvName);
  const botLogoName = useSelector((state: any) => state.counter.botLogoName);
  const avtarLogoName = useSelector((state: any) => state.counter.avtarLogoName);
  const uploadPolicyFileName = useSelector((state: any) => state.counter.uploadPolicyFileName);
  const [goSteps, setGoSteps] = useState(0);
  const [is_changedBrandPersonality, setIs_changedBrandPersonality] = useState({});
  const [is_changedUpdatePolicyFile, setIs_changedUpdatePolicyFile] = useState("");
  const [is_csvFile, setIs_csvFile] = useState("");
  const [apiData, setApiData] = useState<any>({});
  const [items, setItems] = useState<Item[]>([]);
  const [tables, setTables] = useState<table_type[]>([]);
  const actions: Industry[] = [
    { name: "Product Search and Recommendation" },
    { name: "Login Tool" },
    { name: "Faq Tool" },
    { name: "Other Tool" },
    { name: "Policy Tool" },
    // { name: "product Search" },
    // { name: "login_tool" },
    // { name: "faq_tool" },
    // { name: "other_tool" },
  ];
  const [actionList, setActionList] = useState<Industry[]>(actions);
  const {
    // handleSubmit,
    // register,
    // formState: { errors },
    // control,
    setValue,
    reset
  } = useForm<configurationData>()
  const dispatch = useDispatch();
  const brandGuidelineName = useSelector((state: any) => state.counter.brandGuidelineName);
  const socialMediaPostName = useSelector((state: any) => state.counter.socialMediaPostName);
  const ActionName = (name: string) => {
    switch (name) {
      case "other_tool":
        return "Other Tool";
      case "login_tool":
        return "Login Tool";
      case "product_search":
        return "Product Search and Recommendation";
      case "faq_tool":
        return "Faq Tool";
      case "update_policy_tool":
        return "Policy Tool";
      case "Other Tool":
        return "other_tool";
      case "Login Tool":
        return "login_tool";
      case "Product Search and Recommendation":
        return "product_search";
      case "Faq Tool":
        return "faq_tool";
      case "Policy Tool":
        return "update_policy_tool";
    }
  }

  const databaseType = (name: string) => {
    switch (name) {
      case "MsSQL":
        return "mssql";
      case "MySQL":
        return "mysql";
      case "PostgreSQL":
        return "postgresql";
      case "mssql":
        return "MsSQL";
      case "mysql":
        return "MySQL";
      case "postgresql":
        return "PostgreSQL";
    }
  }

  const capitalFirstLetterOfWord = (word: string) => {
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  }
  const methods = useForm({
    defaultValues: async () => {
      dispatch(handleLoader(true));
      let Client: any = ""
      const env = localStorage.getItem("clientName")
      if (window.location.origin === 'https://ron.rysun.in:3001' && env === "ron_prod") {
        Client = "frida_prod"
      } else if (window.location.origin !== 'https://ron.rysun.in:3001' && env === "ron_stage") {
        Client = "frida"
      } else {
        Client = env
      }
      try {
        const { result, error } = await getBotConfigurations(Client);
        if (error) {
          throw error
        }
        if (result?.error) {
          throw result.error
        }
        // const result = myconst.tempBotObj
        dispatch(setBotLogoName(result.bot_config.bot_logo_name))
        dispatch(setAvtarLogoName(result.bot_config.avatar_logo_name))
        dispatch(setUploadPolicyFileName(result?.upload_policy_file_name))
        dispatch(setcsvName(result?.csv_file_name));
        dispatch(setbrandGuidelineName(result?.brand_guide_file_name));
        dispatch(setsocialMediaPostName(result?.social_media_file_name));
        setIs_changedUpdatePolicyFile(result?.upload_policy_csv_file);
        setIs_csvFile(result?.csv_master_data);
        let found = false;
        const updatedData: any = result?.bot_actions?.map((item: any) => {
          const tableObject = {
            action: { name: ActionName(item.action) },
            prompt: item.prompt,
            tables: item?.tables?.join(',').replace(/\s/g, ''),
            database: item.database_name,
            dialect_database: { name: databaseType(item.dialect_database) },
            host: item.host,
            port: item.port,
            username: item.user_name,
            password: item.password,
          }
          const tableObjectLoginTool = {
            action: { name: ActionName(item.action) },
            prompt: item.prompt,
            database: item.database_name,
            dialect_database: { name: databaseType(item.dialect_database) },
            host: item.host,
            port: item.port,
            username: item.user_name,
            password: item.password,
          }
          const tableObjectProductSearch = {
            action: { name: ActionName(item.action) },
            prompt: item.prompt,
            tables: item?.tables?.join(',').replace(/\s/g, ''),
            database: item.database_name,
            dialect_database: { name: databaseType(item.dialect_database) },
            host: item.host,
            port: item.port,
            username: item.user_name,
            acceptance_threshold: item.acceptance_threshold,
            top_n: item.top_n,
            feature_column_list_input: item.feature_column_list_input?.join(',').replace(/\s/g, ''),
            feature_column_list_output: item.feature_column_list_output?.join(',').replace(/\s/g, ''),
            product_recommendation_tool: item.product_recommendation_tool,
            password: item.password,
          }
          const noTableObject = {
            action: { name: ActionName(item.action) },
            prompt: item.prompt,
          }
          const updatePolicyToolObj = {
            action: { name: ActionName(item.action) },
            product_page_chat_tool_desc: item.product_page_chat_tool_desc,
            return_policy_tool: item.return_policy_tool,
          }
          if (item.tables === undefined || item.tables === null) {
            if (item.action === "update_policy_tool") {
              return updatePolicyToolObj
            } else if (item.action === "login_tool") {
              const temp = item.tables_data.map((it: table_type_getting) => {
                const temp = {
                  table_name: it.table_name,
                  column_name: it.column_name.join(',')
                }
                return temp
              })
              setTables(temp)
              return tableObjectLoginTool
            } else {
              return noTableObject
            }
          } else {
            if (item.action === "product_search") {
              return tableObjectProductSearch
            } else {
              return tableObject
            }
          }
        })
        setItems(updatedData)
        const tempObject = {
          brand_guide_file: result.brand_guide_file,
          social_media_file: result.social_media_file,
          personalities: result.personalities,
          traits: result.traits,
        }
        setIs_changedBrandPersonality(tempObject);
        const valueObj = {
          csv_master_data: result.csv_master_data,
          industry: { name: result.industry.charAt(0).toUpperCase() + result.industry.slice(1) },
          organization_name: result.organization_info.organization_name,
          organization_url: result.organization_info.organization_url,
          botName: result.bot_config.bot_name,
          tagline: result.bot_config.tagline,
          initialMessage: result.bot_config.initial_message,
          botLogo: result.bot_config.bot_logo,
          avatarLogo: result.bot_config.avatar_logo,
          headerColor: result?.bot_config?.header_colour,
          questionBackgroundColor: result.bot_config.question_background_colour,
          answerBackgroundColor: result.bot_config.answer_background_colour,
          fontSize: { name: result.bot_config.font_size.toString() },
          brand_guide_file: result.brand_guide_file,
          social_media_file: result.social_media_file,
          personalities: result.personalities.map((i: any) => ({ name: capitalFirstLetterOfWord(i) })),
          traits: result.traits.map((i: any) => ({ name: capitalFirstLetterOfWord(i) })),
          upload_policy_file: result.upload_policy_csv_file,
          // host: result.structured_params.host,
          // port: Number(result.structured_params.port),
          // username: result.structured_params.user_name,
          // password: result.structured_params.password,
          // database: result.structured_params.db_name,
        }
        setApiData(valueObj);
        dispatch(handleLoader(false));
        return valueObj;
      } catch (error: any) {
        dispatch(handleLoader(false));
        toast.error(error, {
          style: {
            backgroundColor: '#F1F1F1', // Grey background
          }
        });
        return {};
      }
    }
  });
  const onSubmit = async (data: any) => {
    if (data.csv_master_data !== "" && data.csv_master_data !== undefined) {
      const updatedData = items.map(item => {
        const tableObject = {
          action: ActionName(item.action.name),
          prompt: item.prompt,
          tables: item?.tables?.split(","),
          database_name: item?.database,
          dialect_database: databaseType(item?.dialect_database?.name),
          host: item?.host,
          port: Number(item?.port),
          user_name: item?.username,
          password: item?.password,
          // showPassword: false
        }
        const tableObjectLoginTool = {
          action: ActionName(item.action.name),
          prompt: item.prompt,
          tables_data: tables.map((it: table_type) => {
            const temp = {
              table_name: it.table_name,
              column_name: it.column_name.split(',')
            }
            return temp
          }),
          database_name: item?.database,
          dialect_database: databaseType(item?.dialect_database?.name),
          host: item?.host,
          port: Number(item?.port),
          user_name: item?.username,
          password: item?.password,
          // showPassword: false
        }
        const tableObjectProductSearch = {
          action: ActionName(item?.action?.name),
          prompt: item.prompt,
          tables: item?.tables?.split(","),
          database_name: item.database,
          dialect_database: databaseType(item?.dialect_database?.name),
          host: item.host,
          port: item.port,
          user_name: item.username,
          acceptance_threshold: item.acceptance_threshold,
          top_n: item.top_n,
          feature_column_list_input: item.feature_column_list_input?.split(","),
          feature_column_list_output: item.feature_column_list_output?.split(","),
          product_recommendation_tool: item.product_recommendation_tool,
          password: item.password,
        }
        const noTableObject = {
          action: ActionName(item.action.name),
          prompt: item.prompt,
        }
        const updatePolicyToolObj = {
          action: ActionName(item.action.name),
          product_page_chat_tool_desc: item?.product_page_chat_tool_desc,
          return_policy_tool: item?.return_policy_tool,
        }
        if (item.tables === undefined) {
          if (item.action.name === "Policy Tool") {
            return updatePolicyToolObj
          } else if (item.action.name === "Login Tool") {
            return tableObjectLoginTool
          } else {
            return noTableObject
          }
        } else {
          if (item.action.name === "Product Search and Recommendation") {
            return tableObjectProductSearch
          } else {
            return tableObject
          }
        }

      })
      const tempObject = {
        brand_guide_file: data.brand_guide_file,
        social_media_file: data.social_media_file,
        personalities: data.personalities.map((i: any) => i.name.toLowerCase()),
        traits: data.traits.map((i: any) => i.name.toLowerCase()),
      }
      let Client: string | null = ""
      const env = localStorage.getItem("clientName")
      if (window.location.origin === 'https://ron.rysun.in:3001' && env === "ron_prod") {
        Client = "frida_prod"
      } else if (window.location.origin !== 'https://ron.rysun.in:3001' && env === "ron_stage") {
        Client = "frida"
      } else {
        Client = env
      }
      const checkUpdateFile = is_changedUpdatePolicyFile === data.upload_policy_file
      const checkUpdateFileCSV = is_csvFile === data.csv_master_data
      // console.log(is_changedUpdatePolicyFile, data.upload_policy_file)
      const data1 = {
        bot_name: Client,
        industry: data.industry.name.toLowerCase(),
        organization_info: {
          organization_name: data.organization_name,
          organization_url: data.organization_url,
        },
        bot_config: {
          bot_name: data.botName,
          tagline: data.tagline,
          initial_message: data.initialMessage,
          bot_logo: data.botLogo,
          bot_logo_name: botLogoName,
          avatar_logo_name: avtarLogoName,
          avatar_logo: data.avatarLogo,
          header_colour: data.headerColor,
          question_background_colour: data.questionBackgroundColor,
          answer_background_colour: data.answerBackgroundColor,
          font_size: Number(data.fontSize.name)
        },
        bot_actions: updatedData,
        csv_file_name: csvName,
        csv_master_data: data.csv_master_data,
        is_csv_updated: !checkUpdateFileCSV,
        brand_guide_file_name: brandGuidelineName,
        social_media_file_name: socialMediaPostName,
        brand_guide_file: data.brand_guide_file,
        social_media_file: data.social_media_file,
        personalities: data.personalities.map((i: any) => i.name.toLowerCase()),
        traits: data.traits.map((i: any) => i.name.toLowerCase()),
        brand_personality_update: !_.isEqual(is_changedBrandPersonality, tempObject),
        upload_policy_csv_file: data.upload_policy_file,
        upload_policy_file_name: uploadPolicyFileName,
        upload_policy_csv_updated: !checkUpdateFile,
        created_by: localStorage.getItem("username")
      }
      // console.log("data1", data1)
      dispatch(handleLoader(true));
      try {
        let { result, error } = await botConfigurations(data1);
        if (error) {
          throw error
        }
        if (result?.error) {
          throw result.error
        }
        dispatch(handleLoader(false));
        toast.success(result.message, {
          style: {
            backgroundColor: '#F1F1F1', // Grey background
          }
        });
      } catch (error) {
        dispatch(handleLoader(false));
        toast.error(error as ToastContent<unknown>, {
          style: {
            backgroundColor: '#F1F1F1', // Grey background
          }
        })
      }
    } else {
      toast.error("Please upload Excel file for schema mapping", {
        style: {
          backgroundColor: '#F1F1F1', // Grey background
        }
      })
    }
  }
  const handleActionList = (actions: Industry[], objectsArray: Item[]) => {
    const temp = actions.filter(action =>
      objectsArray.every(obj => obj.action.name !== action.name)
    );
    return temp
  };

  useEffect(() => {
    if (items.length > 0) {
      setActionList(handleActionList(actions, items))
    } else {
      setActionList(actions);
    }
  }, [items])
  useEffect(() => {
    dispatch(handleNotFound(false));
  }, [])

  const handleStes = (steps: number) => {
    switch (steps) {
      case 0:
        // return <StepOne handleNext={() => setGoSteps(1)} />
        return <ConfigurationBot methods={methods} handleNext={() => setGoSteps(1)} />
      case 1:
        return <StepTwo handlePrev={() => setGoSteps(0)} tables={tables} setTables={setTables} actions={actions} items={items} setItems={setItems} actionList={actionList} methods={methods} handleNext={() => setGoSteps(2)} />
      case 2:
        return <BrandPersonality handlePrev={() => setGoSteps(1)} methods={methods} handleNext={() => setGoSteps(3)} />
      case 3:
        return <StepThree handlePrev={() => setGoSteps(2)} />
    }
  }

  return (
    <div className="p-4 content-wrapper configuration-section">
      <div className="card">
        <h4 className="admin-heading">Bot Configuration</h4>
        <FormProvider {...methods} >
          <form onSubmit={methods.handleSubmit(onSubmit, (err) => { console.log("onSubmit", err) })}>
            <Stepper activeStep={goSteps} styleConfig={{ ...defaultStyle, activeBgColor: "#5627D9", completedBgColor: "#5627D9" }}  >
              <Step type="button" onClick={() => setGoSteps(0)} label="Step 1"><span className="extra-info">UI Configuration</span></Step>
              <Step type="button" onClick={() => setGoSteps(1)} label="Step 2"><span className="extra-info">Action Configuration</span></Step>
              <Step type="button" onClick={() => setGoSteps(2)} label="Step 3"><span className="extra-info">Brand Personality</span></Step>
              <Step type="button" onClick={() => setGoSteps(3)} label="Step 4"><span className="extra-info">Schema Mapping</span></Step>
            </Stepper>
            {/* <Steps model={itemsLabel} activeIndex={goSteps} onSelect={(e) => setGoSteps(e.index)} readOnly={false} /> */}
            {handleStes(goSteps)}
          </form>
        </FormProvider>
      </div>
    </div >
  );
}

export default BotConfiguration